'use strict';

import Player from '@vimeo/player';
import { isMobile } from '../utilities/breakpoints'; 

// TODO:
// - Move all dynamic Vimeo settings (autoplay, muted, loop, controls) into data-* attributes in ISML
// - Build iframe src dynamically in JS using these data-* values
// - Inject only one iframe src based on viewport size to improve performance and avoid double loading
// - Add debounce on resize event to limit iframe reload frequency and improve UX
// - Plan future custom player controls (play/pause, volume, fullscreen...)

function setIframeSrc(container, mobileView) {
    var iframe = container.querySelector('iframe');
    if (!iframe) return;

    var baseSrc = mobileView ? iframe.dataset.srcMobile : iframe.dataset.srcDesktop;
    if (!baseSrc) return;

    if (iframe.src !== baseSrc) {
        iframe.src = baseSrc;
    }
}

function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

function initVimeoPlayers() {
    const containers = document.querySelectorAll('.js-vimeo-player');
    if (!containers.length) return;

    let mobileView = isMobile();

    containers.forEach(container => {
        setIframeSrc(container, mobileView);

        const iframe = container.querySelector('iframe');
        if (!iframe) return;

        const player = new Player(iframe);

        // Start muted by default
        player.setVolume(0);

        // Play / Pause toggle button
        const btnPlayPause = container.querySelector('.btn-play-pause');
        
        if (btnPlayPause) {
            const iconPlay = btnPlayPause.querySelector('.icon-play');
            const iconPause = btnPlayPause.querySelector('.icon-pause');
            const ariaLabelPause = btnPlayPause.getAttribute('data-label-pause');
            const ariaLabelPlay = btnPlayPause.getAttribute('data-label-play');
            
            // Initialize button label
            player.getPaused().then(paused => {
                if (paused) {
                    iconPlay?.classList.add('d-none');
                    iconPause?.classList.remove('d-none');
                    btnPlayPause.setAttribute('aria-label', ariaLabelPause);
                } else {
                    iconPlay?.classList.remove('d-none');
                    iconPause?.classList.add('d-none');
                    btnPlayPause.setAttribute('aria-label', ariaLabelPlay);
                }
            });

            btnPlayPause.addEventListener('click', () => {
                player.getPaused().then(paused => {
                    if (paused) {
                        player.play();

                        // Update icons
                        iconPlay?.classList.add('d-none');
                        iconPause?.classList.remove('d-none');
                        btnPlayPause.setAttribute('aria-label', ariaLabelPause);
                    } else {
                        player.pause();

                        // Update icons
                        iconPlay?.classList.remove('d-none');
                        iconPause?.classList.add('d-none');
                        btnPlayPause.setAttribute('aria-label', ariaLabelPlay);
                    }
                });
            });
        }

        // Mute / Unmute toggle button
        const btnMuteUnmute = container.querySelector('.btn-mute-unmute');
        if (btnMuteUnmute) {
            // Initialize button label as 'Unmute' since volume is 0
            btnMuteUnmute.textContent = 'Unmute';

            btnMuteUnmute.addEventListener('click', () => {
                player.getVolume().then(volume => {
                    if (volume === 0) {
                        player.setVolume(1);
                        btnMuteUnmute.textContent = 'Mute';
                    } else {
                        player.setVolume(0);
                        btnMuteUnmute.textContent = 'Unmute';
                    }
                });
            });
        }
    });

    window.addEventListener('resize', debounce(() => {
        const currentMobileView = isMobile();
        if (currentMobileView !== mobileView) {
            mobileView = currentMobileView;
            containers.forEach(container => setIframeSrc(container, mobileView));
        }
    }));
}

export default initVimeoPlayers;
